import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      // set both token and user at once
      setSession: ({ token, user }) => {
        set({ token, user });
      },

      // update just user fields
      updateUser: (partial) => set({ user: { ...get().user, ...partial } }),

      logout: () => {
        set({ token: null, user: null });
      },
    }),
    {
      name: "zap-auth", // localStorage key
      storage: createJSONStorage(() => localStorage),
      // keep only what you need
      partialize: (state) => ({ token: state.token, user: state.user }),
    }
  )
);
